<template>
  <div>
    <v-container class="pt-0">
      <span class="headline">{{$t('friends.find-friends')}}</span>
      <form action="/" @submit="submitSearch">
        <v-row :no-gutters="true" class="align-center">
          <v-col cols="12" md="8" sm="6">
            <v-text-field
              v-model="searchInput"
              name="search"
              type="text"
              label="Nickname / E-Mail-Adresse / Online-ID / echter Name"
              :disabled="loading"
              :clearable="true"
            />
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <v-btn
              type="submit"
              class="primary mb-1"
              :loading="loading"
              :disabled="!searchFormValid"
            >
              <v-icon left>mdi-magnify</v-icon>{{$t('common.search')}}
            </v-btn>
          </v-col>
        </v-row>
      </form>

      <div v-if="results && results.length > 0">
        <v-row>
          <v-col>
            <span class="headline pl-0">{{$t('common.search-results')}}:</span>
          </v-col>
        </v-row>
        <v-row v-for="user in results" v-bind:key="user.id" :no-gutters="true" class="align-center">
          <v-col lg="8" md="6">
            <user-widget :user="user" :showDefaultActions="[]" />
          </v-col>
          <v-col lg="4" md="6" class="text-right">
            <v-btn
              v-if="user.friendship !== true"
              class="mx-2 secondary"
              large
              @click="requestFriendship(user)"
              :loading="loadingFriendRequest"
            >
              <v-icon left>mdi-plus-circle</v-icon>Anfrage
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-if="results && results.length == 0">
        <v-row>
          <v-col>
            <span>Es wurde leider kein Benutzer gefunden</span>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store.js";

export default {
  name: "SearchFriends",

  components: {
  },

  data: () => ({
    loading: false,
    loadingFriendRequest: false,
    searchInput: undefined,
    results: undefined
  }),

  computed: {
    searchFormValid() {
      return this.searchInput && this.searchInput.trim().length > 0;
    }
  },

  mounted() {
    // this.search()
  },

  methods: {
    submitSearch(e) {
      e.preventDefault();
      if (this.searchFormValid) {
        this.search();
      }
    },
    search() {
      this.loading = true;
      // console.log("Searching...");
      this.searchInput = this.searchInput.trim();
      this.$http
        .get("/api/friend/search", { params: { search: this.searchInput } })
        .then(response => {
          this.loading = false;
          let data = response.data;
          // console.log(data.users);
          this.results = data.users;
        })
        .catch(error => {
          // also catches the store authorized error
          this.loading = false;
          this.$common.onError(error)
        });
    },
    requestFriendship(user) {
      console.log("Requesting friendship @ " + user.uid);
      this.error = undefined;
      this.loadingFriendRequest = true;
      this.$api
        .requestFriendship(user.uid)
        .then(() => {
          this.loadingFriendRequest = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: `Freundschaftsanfrage an '${user.name}' gestellt`,
            type: "success"
          });
        })
        .catch(error => {
          // also catches the store authorized error
          this.loadingFriendRequest = false;
          this.$common.onError(error)
        });
    }
  }
};
</script>
